import React from "react";

const JQuery_Ancestors = () => {
  return (
    <div>
      <h1>JQuery_Ancestors</h1>
      <p>Placeholder component for: "JQuery_Ancestors"</p>
    </div>
  );
};

export default JQuery_Ancestors;
